import { getToken } from '@helpscout/hsds-tokens/getToken'
import { css } from 'styled-components'

export const focusShadow = `
  0 0 0 var(--focusRingSize, ${getToken(
    'measure.focusRing.innerBoxShadowSize'
  )}) var(--hsds-focus-ring-color, ${getToken(
  'color.focusRing.default.innerColor'
)}),
  0 0 0 var(--focusRingOuterSize, ${getToken(
    'measure.focusRing.outerBoxShadowSize'
  )}) var(--hsds-focus-ring-outer-color, ${getToken(
  'color.focusRing.default.outerColor'
)});
`

export const focusShadowWithInset = `
  0 0 0 var(--focusRingSize, ${getToken(
    'measure.focusRing.innerBoxShadowSize'
  )}) var(--hsds-focus-ring-color, ${getToken(
  'color.focusRing.default.innerColor'
)}),
  0 0 0 var(--focusRingOuterSize, ${getToken(
    'measure.focusRing.outerBoxShadowSize'
  )}) var(--hsds-focus-ring-outer-color, ${getToken(
  'color.focusRing.default.outerColor'
)}),
  inset 0 0 0 var(--focusRingSize, ${getToken(
    'measure.focusRing.insetBoxShadowSize'
  )}) white;
`

export const focusRing = css`
  --hsds-focus-ring-color: ${getToken('color.focusRing.default.innerColor')};
  --hsds-focus-ring-outer-color: ${getToken(
    'color.focusRing.default.outerColor'
  )};
  --hsds-focus-ring-offset: -2px;
  --hsds-focus-ring-shadow: ${focusShadow};
  --hsds-focus-ring-radius: 0px;
  --offsetValue: min(var(--hsds-focus-ring-offset), 0px);
  --gap: calc(max(var(--offsetValue), -1 * var(--offsetValue)) - 1px);

  outline: none;
  position: relative;

  &:before {
    content: '';
    border-radius: calc(var(--hsds-focus-ring-radius) + var(--gap));
    inset: var(--hsds-focus-ring-offset);
    box-shadow: var(--hsds-focus-ring-shadow);
    pointer-events: none;
    position: absolute;
    opacity: 0;
    background: transparent;
    z-index: 3;
  }

  &:focus {
    &:before {
      opacity: 1;
    }
  }

  &:focus:not(:focus-visible) {
    &:before {
      opacity: 0;
    }
  }

  &:focus-visible {
    &:before {
      opacity: 1 !important;
      transition: opacity ease 0.2s;
    }
  }

  &.is-focused {
    &:before {
      opacity: 1 !important;
    }
  }

  /* Forced colors mode drops box shadows, which would leave no focus indicator. */
  @media (forced-colors: active) {
    &:focus-visible,
    &.is-focused {
      outline: 2px solid Highlight;
      outline-offset: 1px;
    }
  }
`
export const focusRingDark = css`
  --hsds-focus-ring-color: ${getToken(
    'color.focusRing.default.innerColorOverDark'
  )};
  --hsds-focus-ring-outer-color: ${getToken(
    'color.focusRing.default.outerColorOverDark'
  )};
`

/**
 * Get a focus ring box-shadow value and customize how many pixels to offset it outwards.
 * Caveat: The offset space between your element and the ring is always white and not transparent
 * @param offset How many pixels to push the box shadow
 * @returns string  A box-shadow value
 */
export function getFocusRingBoxShadow(offset: number): string {
  return `
  0 0 0 ${offset}px white,
  0 0 0 ${offset + 1}px var(--hsds-focus-ring-color, ${getToken(
    'color.focusRing.default.innerColor'
  )}),
  0 0 0 ${offset + 3}px var(--hsds-focus-ring-outer-color, ${getToken(
    'color.focusRing.default.outerColor'
  )});
`
}
